import { v3 } from "@alchemiesolns/maths";
import AtomContainer from "./AtomContainer";
import IBondModel from "./IBondModel";
import IAtomModel from "./IAtomModel";

export const AtomContainerQuery = {
    findCentralAtoms: (container: AtomContainer) => {
        // The definition for central atom used by alt-text is any atom that has more than two
        // connections.
        return container.atoms.filter(a => container.getBondsAttachedTo(a).length > 1);
    },
    getBondDirection: (bond: IBondModel) => {
        const a1 = bond.a1;
        const a2 = bond.a2;
        if(!a1.pos || !a2.pos) {
            return [0,0,0];
        }
        const p1 = [a1.pos.x, a1.pos.y, a1.pos.z ?? 0];
        const p2 = [a2.pos.x, a2.pos.y, a2.pos.z ?? 0];
        return v3.directionTo(p1, p2);
    },
    getBondsAttachedTo: (a: IAtomModel, bonds: IBondModel[]) => {
        return bonds.filter(b => b.a1 === a || b.a2 === a);
    },
    getAtomsSortedByNumberOfBonds: (container: AtomContainer) => {
        const sorted = container.atoms.slice();
        sorted.sort((a, b) => {
            const numA = AtomContainerQuery.getBondsAttachedTo(a, container.bonds).length;
            const numB = AtomContainerQuery.getBondsAttachedTo(b, container.bonds).length;
            return numB - numA;
        })
        return sorted;
    },
    getBondBetween: (container: AtomContainer, a1: IAtomModel, a2: IAtomModel) => {
        const bonds = container.bonds.filter(b => (b.a1 === a1 && b.a2 === a2) || (b.a1 === a2 && b.a2 === a1));
        return bonds[0] || null;
    },
    getImplicitHydrogensAttachedTo: (a: IAtomModel, container: AtomContainer, excludeVisibleHydrogen = false) => {
        const bonds = container.getBondsAttachedTo(a);
        return bonds.filter(b => {
            const otherAtom = b.getOtherAtom(a)
            const isRightType = b.order === 1 &&
                otherAtom.symbol === "H" &&
                container.getBondsAttachedTo(otherAtom).length === 1
            const shouldBeImplicit = excludeVisibleHydrogen ? otherAtom.visible === false : true;
            return isRightType && shouldBeImplicit
        }).map(b => b.getOtherAtom(a));
    },
    getImplicitHydrogens: (container: AtomContainer, excludeVisibleHydrogen = false) => {
        return container.atoms.filter(a => {
            if(excludeVisibleHydrogen && a.visible === true) return false;

            if(a.symbol !== "H") return false;

            const bonds = container.getBondsAttachedTo(a);
            if(bonds.length !== 1) return false;

            const other = bonds[0].getOtherAtom(a);
            if(other.symbol === "H") return false;

            return true;
        })
    }

}